
import moment from 'moment';
const formatoModena = new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
});

const opcionesFecha = { timeZone: 'America/Mexico_City',weekday: "long", year: "numeric", month: "long", day: "numeric",hour: "numeric",minute:"numeric",second:"numeric", hour12:"false" };

const servicioFormatos = {

    formatearModena(valor) {
       return formatoModena.format(valor);
    },

    formatearFecha(valor) {        
        let fecha  = new Date(valor);
        return fecha.toLocaleString('es-MX',opcionesFecha);
    },
    formatearFechaString(valor) {
        if(null===valor || undefined===valor){
          return null;
        } else{
          let fecha = moment(valor).format('YYYY-MM-DD HH:mm:ss');
          return fecha;
        }       
      },
    
}

export default servicioFormatos;